export default __webpack_public_path__ + "assets/icons/message_error.149e3cde.svg";